// Folds Private into the Home surface as a third scope tab; the dedicated
// Private entries disappear from the left sidebar and mobile navbar while on.
export const homePrivateEnabled = () =>
    !!window.gon?.currentUser?.features?.some((f: { name: string }) => f.name === 'home_private')
